import { Action } from './enum/action';
import { AppAction } from './reducer';

export function stopLoading(): AppAction {
  return {
    type: Action.APP_SET_IS_LOADING,
    payload: {
      isLoading: false,
    },
  };
}

export function startLoading(): AppAction {
  return {
    type: Action.APP_SET_IS_LOADING,
    payload: {
      isLoading: true,
    },
  };
}

export function setViewportWidth(viewportWidth: number): AppAction {
  return {
    type: Action.SET_VIEWPORT_WIDTH,
    payload: {
      viewportWidth,
    },
  };
}
